import script from "./OwnerActions.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnerActions.vue?vue&type=script&setup=true&lang=js"

import "./OwnerActions.vue?vue&type=style&index=0&id=bfca632a&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfca632a"]])

export default __exports__